import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('KYE/GetList', { params });
  },
  getDetail(_, id) {
    return axios.get('KYE/GetDetail', { params: { id } });
  },
  approve(_, id) {
    return axios.get('KYE/Approve', { params: { id } });
  },
  save(_, form) {
    return axios.post('KYE/save', form);
  },
  saveWithFile(_, formData) {

    return axios.post('KYE/SaveWithFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  delete(_, id) {
    return axios.get('KYE/Delete', { params: { id } });
  },
};
